'use strict';

angular.module('mobile-apps')
	.service('FullscreenModal', ['$modal', '$rootScope', function($modal, $rootScope) {
        return {
			open: function(scope, opts) {

				if (!opts) {
					opts = {};
				}

				// Add options to display the fullscreen modal correctly
				opts = angular.extend({
					backdrop: false,
					scope: scope,
					windowTemplateUrl: 'modules/mobile-apps/views/fullscreen.client.directive.html'
				}, opts);

				var modalInstance = $modal.open(opts);

				scope.closeModal = function() {
					modalInstance.close();
				};

				return modalInstance;
			}
		};
    }
]);

